import makeStyles from '@mui/styles/makeStyles';

export default makeStyles({
  cardBody: {
    padding: '0.9375rem 1.875rem',
    flex: '1 1 auto',
  },
});
